Bingo.WysiwygEditor = {};
Bingo.WysiwygEditor.init = (element) => {
    CKEDITOR.replace(element);
    CKEDITOR.on('dialogDefinition', (event) => {
        const definition = event.data.definition;
        definition.width = 720;
    });
};
